import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ToastService } from '../../core/services/toast.service';

/** Pilha de toasts do design system (canto inferior direito). */
@Component({
  selector: 'loggic-toast',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="fixed bottom-5 right-5 z-50 flex flex-col gap-2">
      @for (t of toasts.toasts(); track t.id) {
        <div
          class="card flex items-center gap-3 py-3 px-4 shadow-lg"
          [class.badge-danger]="t.kind === 'danger'"
        >
          <span
            class="inline-block h-2 w-2 rounded-full"
            [class.bg-success]="t.kind === 'success'"
            [class.bg-warning]="t.kind === 'warning'"
            [class.bg-danger]="t.kind === 'danger'"
            [class.bg-accent]="t.kind === 'info'"
          ></span>
          <span class="text-sm text-fg">{{ t.message }}</span>
          <button class="btn-ghost btn text-xs" (click)="toasts.dismiss(t.id)">Fechar</button>
        </div>
      }
    </div>
  `,
})
export class ToastComponent {
  protected readonly toasts = inject(ToastService);
}
